export const getWorkaroundSummaryFormFields = (
    workaroundNeeded: boolean,
    runtimeHoursEnabled: boolean
  ) => [
    {
      key: 'itApplicationId',
      hidden: true,
    },
    {
      label: 'Maximum Tolerable Outage (MTO)',
      type: 'time',
      key: 'mto',
      decoratorWord: 'hours',
      tooltip:
        'To fill in this value, you need to go to Data Inputs/IT Applications.',
      disabled: true,
    },
    {
      label: 'Recovery Time Objective (RTO)',
      type: 'time',
      key: 'rto',
      decoratorWord: 'hours',
      tooltip:
        'To fill in this value, you need to go to Data Inputs/IT Applications.',
      disabled: true,
    },
    {
      label: 'Recovery Point Objective (RPO)',
      type: 'time',
      key: 'rpo',
      decoratorWord: 'hours',
      tooltip:
        'To fill in this value, you need to go to Data Inputs/IT Applications.',
      disabled: true,
    },
    {
      label: 'Service Level Agreement (SLA)',
      type: 'time',
      key: 'sla',
      decoratorWord: 'hours',
      tooltip:
        'To fill in this value, you need to go to Data Inputs/IT Applications.',
      disabled: true,
    },
    {
      label: 'Workaround Needed?',
      key: 'isWorkaroundNeeded',
      type: 'boolean',
    },
    {
      label: 'Workaround Defined',
      key: 'workaroundDefined',
      type: 'select',
      options: [
        { label: 'Infinite', value: 'INFINITE' },
        { label: 'Defined Time', value: 'DEFINED_TIME' },
        { label: 'N/A', value: 'NO_WORKAROUND' },
      ],
      disabled: !workaroundNeeded,
    },
    {
      label: 'Runtime with Workaround',
      key: 'runtimeHours',
      type: 'time',
      decoratorWord: 'hours',
      placeholder: 'hola',
      disabled: !workaroundNeeded || !runtimeHoursEnabled,
    },
    {
      label: 'Max. Allowable Data Loss',
      key: 'maxDataLossHours',
      type: 'time',
      decoratorWord: 'hours',
      disabled: !workaroundNeeded,
    },
    {
      label: 'Workaround Description',
      key: 'workaroundDescription',
      type: 'textArea',
      disabled: !workaroundNeeded,
    },
  ];